import script from "/app/components/alert.vue?type=script";
import "/app/components/alert.vue?type=style";
import { render } from "/app/components/alert.vue?type=template";
script.render = render;
export default script;
